// extracted by mini-css-extract-plugin
export var cartContainer = "_p3-4";
export var gray = "_p3-1";
export var itemContainer = "_p3-2";
export var itemDetails = "_p3-3";
export var strong = "_p3-0";